var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "alert alert-success" }, [
      _vm.header
        ? _c("h3", { class: { mbn: !_vm.text } }, [_vm._v(_vm._s(_vm.header))])
        : _vm._e(),
      _vm._v(" "),
      _vm.text
        ? _c("div", { domProps: { innerHTML: _vm._s(_vm.text) } })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.data.pdfUrl
        ? _c(
            "a",
            {
              staticClass: "btn btn-primary pull-left",
              attrs: { href: _vm.data.pdfUrl, target: "_blank" },
            },
            [
              _vm._v(_vm._s(_vm.$t("btn_label_pdf")) + " "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(" otwiera się w nowej karcie"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary pull-right",
          attrs: { type: "button" },
          on: { click: _vm.reload },
        },
        [_vm._v(_vm._s(_vm.$t("btn_label_close")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }